'use client';

import React from 'react';
import CheckoutStepper from '@/components/customercenter-ui/checkout/common/stepper/checkout-stepper';
import Checkout from '../../../../components/customercenter-ui/checkout';
import { TasticProps } from '../../types';

const CheckoutTastic = ({ data }: TasticProps<any>) => {
  return (
    <>
      {data?.showHeader && (
        <section className="mb-5 w-full bg-lightSilver ">
          <section className="max-w-screen-9xl mx-auto px-4">
            <section className="py-10 lg:flex lg:gap-60">
              <p className="flex justify-center"></p>
              <CheckoutStepper />
            </section>
          </section>
        </section>
      )}
      <Checkout data={data} />
    </>
  );
};

export default CheckoutTastic;
